import { render, staticRenderFns } from "./Brand2.vue?vue&type=template&id=96f57918"
import script from "./Brand2.vue?vue&type=script&lang=js"
export * from "./Brand2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports